import api from "./api";
import { useEffect, useState } from "react";
import { useUserSuperEmpresa } from "../Context/AuthContext";

export const cargaMasiva = async (formData) => {
  try {
    const { data } = await api.post("/ingreso/paciente/masiva", formData, {
      headers: {
        "Content-Type": "multipart/form-data", // 👈 importantísimo
      },
    });
    return data;
  } catch (error) {
    throw error.response?.data?.message || "Error al cargar de forma masiva";
  }
};


export const useIngresoPaciente = () => {
  const { Token } = useUserSuperEmpresa();

  const getIngresosMasivos = async (params = {}) => {
    try {
      const { data } = await api.get("/ingresos/actual", {
        params,
        headers: {
          Authorization: `Bearer ${Token}`, // enviamos token
        }
      });
      return data;
    } catch (error) {
      throw error.response?.data?.message || "Error al obtener ingresos";
    }
  };

  const postIngresoPacienteManual = async (params = {}) => {
    try {
      const { data } = await api.post("/ingreso/paciente/store", params, {
        headers: {
          Authorization: `Bearer ${Token}`, // enviamos token
        },
      });
      return data.data;
    } catch (error) {
      throw error.response?.data?.message || "Error al crear ingreso";
    }
  };

  const editarIngresoPaciente = async (id, params = {}) => {
    try {
      const { data } = await api.put(`/ingresos/update/${id}`, params, {
        headers: { Authorization: `Bearer ${Token}` },
      });
      return data;
    } catch (error) {
      throw error.response?.data?.message || "Error al editar el usuario";
    }
  };

  const eliminarIngresoPaciente = async (id) => {
    try {
      const { data } = await api.delete(`/ingresos/delete/${id}`, {
        headers: { Authorization: `Bearer ${Token}` },
      });
      return data;
    } catch (error) {
      throw error.response?.data?.message || "Error al eliminar el usuario";
    }
  };

 const eliminarIngresoPacienteMesyAño = async (mes, anio, branch_id ) => {
  try {
    const { data } = await api.delete(`/eliminar/mes/ano`, {
      headers: { Authorization: `Bearer ${Token}` },
      data: { mes, anio, branch_id }, 
    });
    return data;
  } catch (error) {
    throw error.response?.data?.message || "Error al eliminar los ingresos";
  }
};


  const BusquedaPaciente = async (busqueda) => {
  try {
    const { data } = await api.get(`/ingresos/busqueda/paciente`, {
      params: { busqueda },
      headers: { Authorization: `Bearer ${Token}` },
    });
    return data;
  } catch (error) {
    throw error.response?.data?.message || "Error al buscar el paciente";
  }
};

 const HistorialPaciente = async (busqueda) => {
  try {
    const { data } = await api.get(`/ingresos/historial/paciente`, {
      params: { busqueda },
      headers: { Authorization: `Bearer ${Token}` },
    });
    return data;
  } catch (error) {
    throw error.response?.data?.message || "Error al buscar el paciente";
  }
};

const getInformacionMontos = async (params = {}) => {
    try {
      const { data } = await api.get("/informacion/montos/ingresopacientes", {
        params,
        headers: {
          Authorization: `Bearer ${Token}`, // enviamos token
        }
      });
      return data;
    } catch (error) {
      throw error.response?.data?.message || "Error al obtener ingresos";
    }
  };

  const getInformacionMesesAnterioresMontos = async () => {
  try {
    const { data } = await api.get("/informacion/mesesanteriores/monto/ingresopacientes");
    return data;
  } catch (error) {
    throw error.response?.data?.message || "Error al obtener ingresos";
  }
};


  return { eliminarIngresoPacienteMesyAño,getInformacionMontos, getInformacionMesesAnterioresMontos, getIngresosMasivos, postIngresoPacienteManual, editarIngresoPaciente, eliminarIngresoPaciente, BusquedaPaciente, HistorialPaciente };
}

export const useGetIngresosMasivos = () => {
  const { Token } = useUserSuperEmpresa();
  const { getIngresosMasivos, BusquedaPaciente, HistorialPaciente, getInformacionMontos, getInformacionMesesAnterioresMontos } = useIngresoPaciente();
  const [ingresosPacientes, setIngresosPacientes] = useState([]);
  const [BusquedasPacientes, setBusquedasPacientes] = useState([]);
  const [historialPacientes, setHistorialPacientes] = useState([]);
  const [informacionMontos , setInformacionMontos ] = useState([]);
  const [informacionMontosAnteriores , setInformacionMontosAnteriores ] = useState([]);
  const [loadingsIngresos, setLoadingIngresos] = useState(true);
  const [loadingsIngresosActualMonto, setLoadingIngresosActualMonto] = useState(true);
  const [loadingsIngresosMontos, setLoadingIngresosMontos] = useState(true);
  const [errorIngresos, setErrorIngresos] = useState(null);

  const fetchIngresosPacientes = async (filtros = {}) => {
  setLoadingIngresos(true);

  try {
    const data = await getIngresosMasivos(filtros);
    setIngresosPacientes(data.data);
  } catch (err) {
    setErrorIngresos(
      err.response?.data?.message ||
      "Error al obtener ingresos"
    );
  } finally {
    setLoadingIngresos(false);
  }
};
   useEffect(() => {
    if (Token) fetchIngresosPacientes();
  }, [Token]);

   const fetchInformacionMontos = async () => {
    setLoadingIngresosActualMonto(true);
    try {
      const data = await getInformacionMontos();
      
      setInformacionMontos(data);
    } catch (err) {
      setErrorIngresos(err.response?.data?.message || "Error al obtener sucursales");
    } finally {
      setLoadingIngresosActualMonto(false);
    }
  };

   const fetchInformacionMontosAnteriores = async () => {
    setLoadingIngresosMontos(true);
    try {
      const data = await getInformacionMesesAnterioresMontos();
      
      setInformacionMontosAnteriores(data);
    } catch (err) {
      setErrorIngresos(err.response?.data?.message || "Error al obtener sucursales");
    } finally {
      setLoadingIngresosMontos(false);
    }
  };
   useEffect(() => {
    if (Token) fetchInformacionMontosAnteriores();
  }, [Token]);

  const fetchBusquedaPaciente = async (busqueda) => {
    if (!busqueda) return;
    setLoadingIngresos(true);
    try {
      const data = await BusquedaPaciente(busqueda);


      // ✅ El backend devuelve un array directamente
      const pacientesUnicos = data.filter(
        (item, index, self) =>
          index === self.findIndex((t) => t.rut === item.rut)
      );

      setBusquedasPacientes(pacientesUnicos);

      // ✅ Retorna los datos filtrados
      return pacientesUnicos;
    } catch (err) {
      setErrorIngresos(err.response?.data?.message || "Error al obtener pacientes");
      return [];
    } finally {
      setLoadingIngresos(false);
    }
  };

  useEffect(() => {
    if (Token) fetchInformacionMontos();
  }, [Token]);
  
const fetchHistorialPaciente = async (busqueda) => {
  if (!busqueda) return;

  setLoadingIngresos(true);
  try {
    // 🔹 Crear query params dinámicos
    const params = new URLSearchParams();
    Object.keys(busqueda).forEach(key => {
      if (busqueda[key]) {
        // Para RUT, limpiar puntos y guion
        if (key === 'rut') {
          params.append(key, busqueda[key].replace(/\./g, '').replace(/-/g, ''));
        } else {
          params.append(key, busqueda[key]);
        }
      }
    });

    // 🔹 Llamar al backend con todos los filtros
    const data = await HistorialPaciente(params.toString()); // HistorialPaciente debe aceptar query string
    setHistorialPacientes(data);
  } catch (err) {
    setErrorIngresos(err.response?.data?.message || "Error al obtener pacientes");
  } finally {
    setLoadingIngresos(false);
  }
};



  useEffect(() => {
    if (Token) fetchHistorialPaciente();
  }, [Token]);

  return {
    ingresosPacientes,
    informacionMontos,
    informacionMontosAnteriores,
    loadingsIngresos,
    errorIngresos,
    refetchIP: fetchIngresosPacientes,
    BusquedasPacientes,
    refetchBP: fetchBusquedaPaciente,
    refetchHP: fetchHistorialPaciente,
    historialPacientes,
    loadingsIngresosMontos,
    loadingsIngresosActualMonto
  };
};
